import {SET_BALANCES, SET_RATES} from "../constants";

const defaultState = {
    totalBalance: 0,
    availableBalance: 0,
    rates: { btc: 0, eth: 0, usdt: 0 },
    balances: { btc: 0, eth: 0, usdt: 0 }
};

export default (state = defaultState, action) => {
    switch(action.type) {
        case SET_RATES:
            return { ...state, ...{
                    rates: { ...state.rates, ...action.rates }
                }};
        case SET_BALANCES:
            const rates = state.rates;
            let totalBalance = Object.keys(action.balances).reduce((total, asset) => {
                return +total + action.balances[asset]*(rates[asset] || 0);
            }, 0);
            let availableBalance = Object.keys(action.available_balances).reduce((total, asset) => {
                return +total + action.available_balances[asset]*(rates[asset] || 0);
            }, 0);

            return { ...state, ...{
                    balances: { ...state.balances, ...action.balances },
                    totalBalance,
                    availableBalance
                }};
        default:
    }

    return state;
}
